export default __webpack_public_path__ + "static/ronaldo-sm-1367a0523b184f46e649c85e8974cfab.png";